import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors,
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'cdProductionOrder');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Priority', field: 'Priority', width: 75, suppressSorting: true },
    {
      headerName: 'Production order', field: 'ProductionOrder',
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/purchase-order-enquiry'
      },
      minWidth: 150,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.ProductionOrder) {
          return {
            PurchaseOrder: row.data.ProductionOrder,
            FieldValue: row.data.ProductionOrder
          };
        } else return null;
      },
    },
    { headerName: 'Committed', field: 'CommittedQuantityDisplay', type: 'numericColumn', suppressSorting: true },
    { headerName: 'User ID', field: 'UserId', type: 'numericColumn', suppressSorting: true },
    { headerName: 'Due', field: 'DueDate', type: 'numericColumn', suppressSorting: true },
    { headerName: 'Order status', field: 'OrderStatus', suppressSorting: true },
    { headerName: 'Description', field: 'Description' },
  ],
  Data: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clears:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.cdProductionOrder,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.salesOrderEnquiry.cdProductionOrder.loading,
  gridOptions: state => state.salesOrderEnquiry.cdProductionOrder.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.cdProductionOrder.data.Columns,
  Actions: state => state.salesOrderEnquiry.cdProductionOrder.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)